import styled from '@emotion/styled';
import { focusRing } from '../../../../shared/theme/focusStyles';

/**
 * The modal call-to-action, shared so every modal's primary and secondary
 * buttons read the same: the Settings modal's recipe. `primary` fills with the
 * primary button token and white text; otherwise a surface button with a text
 * border. A disabled or aria-disabled button keeps its fill and dims, so it
 * still reads as the same control. Use aria-disabled (not disabled) when the
 * click must stay live, e.g. to mark form fields touched.
 */
const ModalCtaButton = styled('button')`
  width: 100%;
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  padding: 8px 16px;
  border-radius: 4px;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${({ primary, theme }) => (primary ? theme.colors.buttonPrimaryBg : theme.colors.surface)};
  color: ${({ primary, theme }) => (primary ? theme.colors.white : theme.colors.text)};
  border: ${({ primary, theme }) => (primary ? 'none' : `1px solid ${theme.colors.text}`)};

  &:hover:not(:disabled):not([aria-disabled='true']) {
    ${({ primary, theme }) => (primary ? 'opacity: 0.9;' : `background: ${theme.colors.surfaceSecondary};`)}
  }
  &:disabled, &[aria-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  ${focusRing}
`;

export default ModalCtaButton;
